(function () {
  'use strict';

  angular.module('unit.info').config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {
    $stateProvider
      .state('unitinfo', {
        url: '/unitinfo',
        template: '<ui-view/>',
      })
      .state('unitinfo.view', {
        url: '/view/:id',
        views: {
          'unitinfo@': {
            controller: 'UnitInfoCtrl',
            controllerAs: 'vm',
            template: require('../unit.info/unit.info.html'),
          },
        },
      });
  }
})();
